import { useState } from "react";

export default function CopyLinkButton({ label = "copy link" }: { label?: string }) {
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    const url = window.location.href;
    const title = document.title;
    const shareData = { url, title };
    const nav = navigator as Navigator & {
      canShare?: (data: ShareData) => boolean;
    };
    if (typeof nav.share === "function") {
      try {
        if (!nav.canShare || nav.canShare(shareData)) {
          await nav.share(shareData);
          return;
        }
      } catch {
        /* fall through to clipboard */
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      window.prompt("Copy this link:", url);
    }
  };

  return (
    <button onClick={onClick} className="btn">
      {copied ? "✓ copied" : label}
    </button>
  );
}
